import { render, staticRenderFns } from "./Actscore.vue?vue&type=template&id=ea87fd8a&scoped=true"
import script from "./Actscore.vue?vue&type=script&lang=js"
export * from "./Actscore.vue?vue&type=script&lang=js"
import style0 from "./Actscore.vue?vue&type=style&index=0&id=ea87fd8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea87fd8a",
  null
  
)

export default component.exports